import { createContext, useContext } from "react";
import type { PortalSchema } from "../schema";

/**
 * Context for overriding the portal schema in preview scenarios.
 * When present, hooks like useTemplateContext will use this schema
 * instead of the global store, enabling real-time preview of draft changes.
 */
const PortalSchemaContext = createContext<PortalSchema | null>(null);

interface PortalSchemaProviderProps {
  schema: PortalSchema;
  children: React.ReactNode;
}

export const PortalSchemaProvider: React.FC<PortalSchemaProviderProps> = ({ schema, children }) => (
  <PortalSchemaContext.Provider value={schema}>{children}</PortalSchemaContext.Provider>
);

export const usePortalSchemaContext = () => useContext(PortalSchemaContext);
